var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb-area pos-relative w-100"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"float-right btn-group"},[_c('router-link',{staticClass:"font-medium f12 btn btn-outline-secondary",attrs:{"to":_vm.backUrl}},[_c('i',{staticClass:"bx bx-left-arrow-alt"}),_vm._v("Quay lại")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }